<template>
  <div class="card">
    <!-- Card content -->
    <div class="card-body">
      <!-- Title -->
      <div class="row">
        <div class="col-md-11">
          <h6 class="card-title">
            <a>{{ pergunta.ordemExibicao }} ) {{ pergunta.titulo }}</a>
            <span
              v-if="pergunta.obrigatoria"
              style="color: red; font-weigth: bold"
              >*</span
            >
          </h6>
          <p v-if="pergunta.subTitulo">
        <small>{{pergunta.subTitulo}}</small>
      </p>
        </div>
        <div class="col">
          <!-- <span class="badge badge-success" style="float:rigth"><i class="bi bi-check"></i></span> -->
        </div>
      </div>
      <!-- Text -->
      <p class="card-text" v-html="pergunta.descricao">        
      </p>
      <div style="padding: 10px">
        <!--opcoes de resposta -->
        <div
          style="margin-top: 5px"
          class="row opcoes-resposta opcao-resposta-radio"
        >
          <div
            class="custom-control custom-radio col"
            :key="`${pergunta.perguntaId}_${opcaoResposta.opcaoRespostaId}`"
            v-for="opcaoResposta in pergunta.opcoesResposta"
          >
            <input
              @click="responderPergunta(pergunta, opcaoResposta, $event)"
              type="radio"
              class="custom-control-input"
              :id="`${pergunta.perguntaId}_${opcaoResposta.opcaoRespostaId}`"
              :name="`rbt_${pergunta.perguntaId}`"
            />
            <label
              class="custom-control-label"
              :for="`${pergunta.perguntaId}_${opcaoResposta.opcaoRespostaId}`"
              >{{ opcaoResposta.valor }}</label
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import repostaPerguntaMethodsMixin from "./ResponderPerguntaMixin";
export default {
  mixins: [repostaPerguntaMethodsMixin],
  name: "comp-pergunta-radiobutton",
  props: ["pergunta", "permitirResponder"],
  data() {
    return {
      resposta: "",
      currentPerguntaId: "",
      valorOpcaoResposta: "",
      ultimaOpcaoResposta: null,
    };
  },
  computed: {
    botaoDesabilitado() {
      return this.resposta === "" || !this.permitirResponder;
    },
  },
  methods: {
    responderPergunta(pergunta, opcaoResposta) {
      const { perguntaId, opcaoRespostaId, sessaoFormularioPerguntaId } =
        opcaoResposta;
      if (
        this.ultimaOpcaoResposta &&
        this.ultimaOpcaoResposta == opcaoResposta.opcaoRespostaId
      )
        return;

      this.removerTodasRespostasPergunta(sessaoFormularioPerguntaId);
      this.responderPerguntaMixin({ pergunta, opcaoResposta });
      this.ultimaOpcaoResposta = opcaoRespostaId;
    },
  },
  mounted() {},
};
</script>

<style>
.opcao-resposta-radio {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/PerguntasComponent/RespostaTipoRadioButtonHorizontal.vue